var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "search-form", attrs: { action: "/search" } },
    [
      _c("input", {
        attrs: { type: "hidden", name: "type", value: "article,page,product" }
      }),
      _c("input", {
        attrs: { type: "hidden", name: "options[prefix]", value: "last" }
      }),
      _c(
        "div",
        { staticClass: "input" },
        [
          _c("label", { staticClass: "u-sr-only", attrs: { for: "q" } }, [
            _vm._v("Search")
          ]),
          _c("search-input", {
            ref: "searchInput",
            attrs: {
              placeholder: _vm.placeholderText,
              autocomplete: _vm.enablePredictiveSearch ? "off" : "on"
            },
            on: { keyup: _vm.showSearchResults, focus: _vm.openSearchResults },
            model: {
              value: _vm.searchValue,
              callback: function($$v) {
                _vm.searchValue = $$v
              },
              expression: "searchValue"
            }
          })
        ],
        1
      ),
      _c(
        "v-button",
        { staticClass: "search-form__submit", attrs: { label: "Search" } },
        [
          _c(
            "v-button",
            { staticClass: "desktop-search-icon" },
            [_c("icon", { attrs: { name: "search", size: "32px" } })],
            1
          )
        ],
        1
      ),
      _vm.enablePredictiveSearch
        ? _c("predictive-search-modal", {
            ref: "predictiveSearchModal",
            attrs: { searchTerm: _vm.searchValue }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }